function CoursePopup( ) {
    $('.js-course-popup').fancybox();
}

export { CoursePopup };
